export default "__VITE_ASSET__CsVv4okh__"